/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_HeadingInputs */

const en_home_hero_heading = /** @type {(inputs: Home_Hero_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your coverage.`)
};

const fr_home_hero_heading = /** @type {(inputs: Home_Hero_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre couverture.`)
};

/**
* | output |
* | --- |
* | "Your coverage." |
*
* @param {Home_Hero_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_hero_heading = /** @type {((inputs?: Home_Hero_HeadingInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_HeadingInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_heading(inputs)
	return fr_home_hero_heading(inputs)
});